const withSupervisors = supervisors => prevProject => ({
    ...prevProject,
    supervisors,
});

export default withSupervisors;
